export default "__VITE_ASSET__5411be2c__"